import { render } from "./DashNavigator.vue?vue&type=template&id=6ee494b6"
import script from "./DashNavigator.vue?vue&type=script&lang=js"
export * from "./DashNavigator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__